/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useEffect, useState } from "react";
import AuthContext from "./AuthContext";
import { storage } from "./auth.storage";
import {
  isAuthenticated,
  isSuperAdmin,
  isTenant,
  hasPermission,
} from "./auth.helpers";

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    token: null,
    user: null,
    authRole: null,
    permissions: {},
    isTenantOwner: false,
    isLoading: true,
  });

  useEffect(() => {
    const data = storage.get();

    if (!data || !data.token || !data.user || !data.authRole) {
      setAuthState((s) => ({ ...s, isLoading: false }));
      return;
    }

    setAuthState({
      ...data,
      isLoading: false,
    });
  }, []);

  const login = (payload) => {
    storage.set(payload);

    setAuthState({
      ...payload,
      isLoading: false,
    });
  };

  const logout = () => {
    storage.clear();

    setAuthState({
      token: null,
      user: null,
      authRole: null,
      permissions: {},
      isTenantOwner: false,
      isLoading: false,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...authState,
        login,
        logout,
        isAuthenticated: () => isAuthenticated(authState),
        isSuperAdmin: () => isSuperAdmin(authState),
        isTenant: () => isTenant(authState),
        hasPermission: (key) => hasPermission(authState, key),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
